'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import { FiRefreshCw } from "react-icons/fi";
import Ende from '@/components/home-page/body/end';
import NavBar from '@/components/header/NavBar';
import End from '@/components/footer/end';
import { useLocale } from 'next-intl';
interface FormData {
  name: string;
  email: string;
  message: string;
}

interface CaptchaChallenge {
  question: string;
  answer: number;
}

const ContactForm: React.FC = () => {
    const t = useTranslations('contact');
    const m = useTranslations('Padel-Master-The-Game-message');
  const [enteremail, setEnteremail] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    message: '',
  });
  
  const [captcha, setCaptcha] = useState<CaptchaChallenge>({ question: '', answer: 0 });
  const [captchaInput, setCaptchaInput] = useState<string>('');
  const [captchaValid, setCaptchaValid] = useState<boolean>(false);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);


  const [status, setStatus] = useState<{ type: 'success' | 'error' | '', message: string }>({
    type: '',
    message: '',
  });

  // Generate advanced CAPTCHA
  const generateCaptcha = () => {
    const operations = [
      { op: '+', fn: (a: number, b: number) => a + b },
      { op: '-', fn: (a: number, b: number) => a - b },
      { op: '×', fn: (a: number, b: number) => a * b },
    ];
    
    const num1 = Math.floor(Math.random() * 20) + 1;
    const num2 = Math.floor(Math.random() * 20) + 1;
    const selectedOp = operations[Math.floor(Math.random() * operations.length)];
    
    const answer = selectedOp.fn(num1, num2);
    const question = `${num1} ${selectedOp.op} ${num2} = ?`;
    
    setCaptcha({ question, answer });
    setCaptchaInput('');
    setCaptchaValid(false);
  };

  // Validate CAPTCHA
  const validateCaptcha = (value: string) => {
    const isValid = parseInt(value) === captcha.answer;
    setCaptchaValid(isValid);
    return isValid;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCaptchaInput(value);
    validateCaptcha(value);
  };

  const handleSubmit = async (e: React.FormEvent) => {


    e.preventDefault();
    setStatus({ type: '', message: '' });

    // Validate form
    if (!formData.name || !formData.email || !formData.message) {
      setStatus({ type: 'error', message: m('m1') });
      return;
    }
   
    // Show CAPTCHA if not shown yet
    if (!showCaptcha) {
      setShowCaptcha(true);
      generateCaptcha();
      setStatus({ type: '', message: m('m2') });
      return;
    }

    if (!captchaValid) {
      setStatus({ type: 'error', message: m('m3') });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', message: m('m4') });
        setFormData({ name: '', email: '', message: '' });
        setShowCaptcha(false);
        setCaptchaInput('');
        setCaptchaValid(false);
      } else {
        setStatus({ type: 'error', message: data.error || m('m5') });
      }
    } catch (error) {
      setStatus({ type: 'error', message: m('m6') });
    } finally {
      setLoading(false);
    }
  };
const slide = {
  src_en: "/hero-court/padel-court.avif",
  src_ar: "/hero-court/ملعب-بادل.avif",
  src_de: "/hero-court/padelplatz.avif",
  src_es: "/hero-court/pista-de-padel.avif",
  src_fr: "/hero-court/terrain-de-padel.avif",
  src_it: "/hero-court/campo-da-padel.avif",
  src_nl: "/hero-court/padelbaan.avif",
  src_pt: "/hero-court/quadra-de-padel.avif",
  src_ru: "/hero-court/padel-kort.avif",
  src_sv: "/hero-court/padelbana.avif",
  alt: "Padel Court"
};

  const locales = ['en','ar','de','es','fr','it','nl','pt','ru','sv'] as const;
  type Locale = typeof locales[number];
  const locale = useLocale() as Locale;
  const key = `src_${locale}` as keyof typeof slide;
  const bgImage = slide[key] || slide.src_en;
  return (
    <>
         <style>{`
        @keyframes pulse-ring {
          0% { box-shadow: 0 0 0 0px rgba(255,255,255,0.45); }
          100% { box-shadow: 0 0 0 18px rgba(255,255,255,0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes fadeSlideUp {
          0% { opacity: 0; transform: translateY(40px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .btn-card { animation: pulse-ring 2s ease-out infinite; }
        .btn-crypto { animation: pulse-ring 2s ease-out infinite 1s; }
        .book-float { animation: float 4s ease-in-out infinite; }
        .fade-up-1 { animation: fadeSlideUp 0.8s ease-out 0.2s both; }
        .fade-up-2 { animation: fadeSlideUp 0.8s ease-out 0.5s both; }
        .fade-up-3 { animation: fadeSlideUp 0.8s ease-out 0.8s both; }
        .pay-btn {
          border: 4px solid white;
          color: white;
          border-radius: 9999px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 8px;
          background: rgba(0,0,0,0.4);
          backdrop-filter: blur(8px);
          transition: all 0.3s ease-in-out;
          cursor: pointer;
        }
        .pay-btn:hover {
          background: white;
          color: black;
          transform: scale(1.12);
          box-shadow: 0 0 35px rgba(255,255,255,0.65);
        }
        .pay-btn:active { transform: scale(0.95); }
        .pay-btn:hover svg { color: black; }
      `}</style>

     <NavBar />
    <div >
 <div className="relative ">
  <div
    className="fixed inset-0 -z-10"
    style={{
     
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}
  >
    <div className="absolute inset-0 bg-black bg-opacity-55" />
  </div>
  
 
  <div className="mx-6 mt-32 my-6 relative z-10 border bg-black bg-opacity-30 backdrop-filter backdrop-blur-sm py-6 lg:py-16 rounded-xl">
   <div className="container mx-auto px-6 max-w-5xl  py-8 md:py-0 ">
    <div>
           <h2 className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold fade-up-2 uppercase tracking-wide text-b pb-4 leading-none">{t('contact-us')}</h2>
        <p className="  text-white  lg:max-w-3xl sm:text-lg mb-16">{t('contact-us-description')}
        </p>

        </div>
       
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className='flex flex-col lg:flex-row gap-4 w-full'>
  <div className='w-full'>
      
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
             className="w-full px-4 py-2 border text-white bg-slate-800 placeholder:text-gray-300 border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-b"
              placeholder={t('name')}
           
            />
          </div>

          {/* Email Field */}
          <div className='w-full'>
          
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            className="w-full px-4 py-2 border text-white bg-slate-800 placeholder:text-gray-300 border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-b"
              placeholder={t('email')}
          
            />
          </div>
          </div>
          {/* Name Field */}
        

          {/* Message Field */}
          <div>
           
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              rows={5}
            className="w-full px-4 py-2 border text-white bg-slate-800 placeholder:text-gray-300 border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-b"
              placeholder={t('message')}
       
            />
          </div>

          {/* Advanced CAPTCHA - Only shows after first submit */}
          {showCaptcha && (
            <div className=" animate-fadeIn items-center flex flex-col ">

              
              <div className="bg-b p-1 w-60 rounded-lg shadow-sm mb-4 flex justify-around items-center">
                <p className="text-2xl font-bold text-center text-gray-900 font-mono tracking-wider">
                  {captcha.question}
                </p>
                 <FiRefreshCw size={24}  onClick={() => {
                    generateCaptcha();
                    setCaptchaInput('');
                  }}/>
              </div>

              <div className="relative">
                <input
                  type="number"
                  value={captchaInput}
                  onChange={handleCaptchaChange}
                  className={`px-3 w-60 py-2 border-1 rounded-lg outline-none transition-all text-gray-900 ${
                    captchaInput === ''
                      ? 'border-gray-300 focus:border-b'
                      : captchaValid
                      ? 'border-green-500 bg-green-50'
                      : 'border-red-500 bg-red-50'
                  }`}
                  placeholder={t('answer')}
                
                />
              
              </div>
            </div>
          )}

     {status.message && (
  <p className={`text-sm text-center font-medium ${
    status.type === 'success' ? 'text-green-400' : 
    status.type === 'error'   ? 'text-red-400'   : 
                                'text-white'
  }`}>
    {status.message}
  </p>
)}
          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || (showCaptcha && !captchaValid)}
            className="w-full bg-b text-black py-2 rounded-lg hover:bg-a font-medium hover:text-white transition-colors capitalize"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                {t('sending')}
              </span>
            ) : showCaptcha && !captchaValid ? (
              t('solve')
            ) : (
              t('send')
            )}
          </button>
        </form>
      </div> </div>
          </div>
       </div> 
        <Ende/> 
         <End />
 </>
  );
};

export default ContactForm;